var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasNewLeftNavEnabled
        ? _c("new-main-header", [_vm._v("\n    Account\n  ")])
        : _c("main-header", [
            _c(
              "span",
              { attrs: { slot: "arrow-back" }, slot: "arrow-back" },
              [
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content: "Back to Start Page",
                      placement: "bottom-start",
                    },
                  },
                  [
                    _c("router-link", { attrs: { to: { name: "HomePage" } } }, [
                      _c("i", { staticClass: "el-icon-back" }),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { attrs: { slot: "page-title" }, slot: "page-title" }, [
              _vm._v("Account"),
            ]),
          ]),
      _vm._v(" "),
      _c("main-content", [
        false
          ? _c(
              "div",
              {
                style: _vm.parentMenuStyle,
                attrs: { slot: "horizontal-menu" },
                slot: "horizontal-menu",
              },
              [
                _c(
                  "el-menu",
                  {
                    staticClass: "ring-menu--horizontal",
                    attrs: {
                      "default-active": _vm.selected.index,
                      mode: "horizontal",
                    },
                    on: { select: _vm.selectMenu },
                  },
                  [
                    _c(
                      "el-menu-item",
                      {
                        directives: [
                          {
                            name: "scroll-to",
                            rawName: "v-scroll-to",
                            value: {
                              el: "#customer-details",
                              container: "#main-content",
                              duration: 500,
                              easing: "linear",
                            },
                            expression:
                              "{\n              el: '#customer-details',\n              container: '#main-content',\n              duration: 500,\n              easing: 'linear'}",
                          },
                        ],
                        attrs: { index: "1" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("details.title")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-menu-item",
                      {
                        directives: [
                          {
                            name: "scroll-to",
                            rawName: "v-scroll-to",
                            value: {
                              el: "#customer-locations",
                              container: "#main-content",
                              duration: 500,
                              easing: "linear",
                            },
                            expression:
                              "{\n              el: '#customer-locations',\n              container: '#main-content',\n              duration: 500,\n              easing: 'linear'}",
                          },
                        ],
                        attrs: { index: "2" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("locations.title")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-menu-item",
                      {
                        directives: [
                          {
                            name: "scroll-to",
                            rawName: "v-scroll-to",
                            value: {
                              el: "#customer-invitations",
                              container: "#main-content",
                              duration: 500,
                              easing: "linear",
                            },
                            expression:
                              "{\n              el: '#customer-invitations',\n              container: '#main-content',\n              duration: 500,\n              easing: 'linear'}",
                          },
                        ],
                        attrs: { index: "3" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("invitations.title")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-menu-item",
                      {
                        directives: [
                          {
                            name: "scroll-to",
                            rawName: "v-scroll-to",
                            value: {
                              el: "#customer-client-devices",
                              container: "#main-content",
                              duration: 500,
                              easing: "linear",
                            },
                            expression:
                              "{\n              el: '#customer-client-devices',\n              container: '#main-content',\n              duration: 500,\n              easing: 'linear'}",
                          },
                        ],
                        attrs: { index: "4" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("client_devices.title")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "main-content" }, slot: "main-content" },
          [
            _c("customer-details", {
              attrs: { id: "customer-details", customer: _vm.customer },
            }),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "customer-locations" } },
              [_c("customer-locations", { attrs: { customer: _vm.customer } })],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }